import React, {useState} from 'react';
import {makeStyles} from '@mui/styles';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import {theme} from '../../Theme';

const useStyles = (props: $TSFixMe) =>
  makeStyles(() => ({
    primaryButton: {
      minWidth: 95,
      borderRadius: '50px',
      textTransform: 'inherit',
      backgroundColor: props.color ? props.color : theme.palette.blue.main,
      color: props.textColor ? props.textColor : theme.palette.secondary.main,
      border: `1px solid ${props.borderColor || 'transparent'}`,
      fontWeight: 'normal',
      bottom: 0,
      transition: 'all ease-in 100ms',

      '&:hover': {
        bottom: 4,
        boxShadow: '0px 5px 6px rgba(0,0,0,0.36)',
        backgroundColor: props.hoverColor
          ? `${props.hoverColor} !important`
          : `${theme.palette.primary.main} !important`,
        color: props.hoverTextColor
          ? `${props.hoverTextColor} !important`
          : `${theme.palette.secondary.main} !important`,
        border: `1px solid ${props.hoverBorderColor || 'transparent'}`,
        fontWeight: 'bold',
      },

      '&:disabled': {
        opacity: '40%',
        color: 'inherit',
      },
    },
  }));

export default function PrimaryButton(props: $TSFixMe) {
  const classes = useStyles(props)();
  const [disabled, setDisabled] = useState(false);

  const handleClick = (event: $TSFixMe) => {
    setDisabled(true);
    Promise.resolve(props.onClick(event))
      .then(() => setDisabled(false))
      .catch(() => setDisabled(false));
  };

  const size = props.size ? props.size : 'normal';

  const sizes = {
    small: {
      fontSize: 14,
      height: 36,
      padding: '8px 24px',
    },
    normal: {
      fontSize: 16,
      height: 42,
      padding: '10px 30px',
    },
    large: {
      fontSize: 18,
      height: 48,
      padding: '12px 36px',
    },
  };

  const styles = {
    ...props.style,
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    fontSize: sizes[size].fontSize,
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    height: sizes[size].height,
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    padding: sizes[size].padding,
    lineHeight: '100%',
  };

  return (
    <Button
      onClick={props.onClick && handleClick}
      className={`${classes.primaryButton} ${props.className}`}
      style={styles}
      disabled={props.disabled || disabled || props.loading}
      component={props.component}
      type={props.type || undefined}
      id={props.id || undefined}>
      {props.loading ? (
        <CircularProgress
          size={24}
          style={{color: props.textColor || theme.palette.secondary.main}}
        />
      ) : (
        props.children
      )}
    </Button>
  );
}
